export const useEducation = () => {
  return {
    title: 'Formação Acadêmica',
    items: {
      top: {
        heading: 'Análise e Desenvolvimento de Sistemas',
        subheading: 'Estácio',
        lines: [
          'Ensino superior completo',
          'Iniciado em outubro de 2021 e concluído em março de 2024.',
        ],
      },
      bottom: {
        heading: 'Pós-Graduação em Desenvolvimento Web Full Stack e Cloud Computing',
        subheading: 'Concluído',
        lines: [
          'Iniciado em abril de 2024 e concluído em fevereiro de 2025.',
          'O curso aborda frontend, back-end e integração com serviços em nuvem, com amplo conhecimento em tecnologias como HTML5, CSS3, JavaScript, Bootstrap, Node.js, Next.js, React, Express.js, Docker e Kubernetes.',
          'A experiência prática inclui modelagem de banco de dados, criação de APIs RESTful e implantação de aplicações na nuvem. Desenvolvimento de habilidades em DevOps, integração contínua e entrega contínua (CI/CD) para automação de processos de desenvolvimento e implantação.',
        ],
      },
    },
  };
};
